import { Divider, Tag, Heading } from "@amzn/storm-ui";
import React from "react";

import { CardDetailsSource } from "../../../../types/card";
import type { CardDetail } from "../../../../types/card";

import { CardDetails } from "./CardDetails";
import {
    CardSummaryContainer,
    CardSummaryContent,
    StyledCardFooter,
    StyledDescriptorContainer,
    StyledDescriptorHeading,
    StyledInsightCard,
    StyledInsightCardBody,
    StyledRowReverse,
} from "./styles";

interface CardLayoutProps {
    description: string;
    dataTestId: string;
    details: CardDetail[];
    actions: JSX.Element;
    tag?: string;
    summary?: string;
}

export const CardLayout: React.FunctionComponent<CardLayoutProps> = (
    props: CardLayoutProps,
) => {
    const { dataTestId, description, details, actions, tag, summary } = props;

    return (
        <div>
            <StyledInsightCard data-testid={dataTestId} padding={"medium"}>
                <StyledInsightCardBody direction={"column"}>
                    {tag && (
                        <StyledRowReverse>
                            <Tag variant="beta" label={tag} />
                        </StyledRowReverse>
                    )}
                    <StyledDescriptorContainer>
                        <StyledDescriptorHeading
                            renderAs="h5"
                            title={description}
                            data-testid={`${dataTestId}-card-title-text`}
                        >
                            {description}
                        </StyledDescriptorHeading>
                    </StyledDescriptorContainer>
                    <CardDetails
                        details={details}
                        source={CardDetailsSource.CARD}
                    />
                    <StyledCardFooter>
                        <Divider />
                        {actions}
                    </StyledCardFooter>
                </StyledInsightCardBody>
            </StyledInsightCard>
            {summary && (
                <CardSummaryContainer data-testid={`${dataTestId}-summary`}>
                    <Heading renderAs="h6" color="secondary">
                        Why did we suggest this?
                    </Heading>
                    <CardSummaryContent>{summary}</CardSummaryContent>
                </CardSummaryContainer>
            )}
        </div>
    );
};
